export const isSubscription = (program: any, canWatch: boolean, hasEntitlementStatic?:boolean) => {
    return (
        program &&
        !canWatch &&
        program.purchaseType === 'SVOD' &&
        (hasEntitlementStatic ?? program.hasEntitlementState)
    )
}